// extracted by mini-css-extract-plugin
module.exports = {"banner-carousel":"banner_banner-carousel__oIg4g"};